'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colorsTheme = require('./colorsTheme.js');
var typographyTheme = require('./typographyTheme.js');
var createMuiTheme = require('../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');

var styles = {
  palette: {
    type: 'light',
    primary: {
      main: '#FFFFFF' //White

    },
    secondary: {
      light: '#9E9E9E',
      main: '#212121',
      dark: '#757575',
      contrastText: '#FFFFFF' //White

    },
    error: colorsTheme.error,
    alert: colorsTheme.alert,
    success: colorsTheme.success,
    info: colorsTheme.info,
    common: colorsTheme.common,
    grey: colorsTheme.grey,
    background: {
      paper: '#FFFFFF' //White

    }
  },
  customShadows: {
    card: '0px 0px 12px 2px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1)'
  },
  spacer: typographyTheme.spacer,
  typography: typographyTheme.typography,
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        borderBottom: 'solid 1px #9E9E9E'
      }
    }
  }
};
var lightTheme = createMuiTheme(styles);

exports.lightTheme = lightTheme;
exports.styles = styles;
